class CCPAForm extends HTMLElement {
    constructor() {
        super();

        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleFieldUpdate = this.handleFieldUpdate.bind(this);
    }

    connectedCallback() {
        this.signupButton = this.querySelector('#sign-up-btn');
        this.signupForm = this.querySelector('#form-primary--retailer');

        this.residencySelect = this.querySelector('#state-of-residency');
        this.requestForm = this.querySelector('#ccpa-request-form');
        this.requestNotice = this.querySelector('#ccpa-request-notice');

        this.fields = this.querySelectorAll('.ccpa-request-form .field-secondary');

        this.initializeSignupForm();
        this.initializeRequestForm();
        this.initializeFields();
    }

    disconnectedCallback() {
        if (this.signupButton != null) {
            this.signupButton.removeEventListener('click', this.handleSignupClick);
        }

        if (this.residencySelect != null) {
            this.residencySelect.removeEventListener('change', this.handleStateChange);
        }

        for (let i = 0; i < this.fields.length; i++) {
            const field = this.fields[i];

            field.removeEventListener('click', this.handleFieldUpdate);
            field.removeEventListener('input', this.handleFieldUpdate);
            field.removeEventListener('focusout', this.handleFieldUpdate);
        }
    }

    initializeSignupForm() {
        if (this.signupButton != null && this.signupForm != null) {
            this.handleSignupClick = () => {
                this.signupButton.classList.add('hidden');
                this.signupForm.classList.remove('hidden');
            };

            this.signupButton.addEventListener('click', this.handleSignupClick);
        }
    }

    initializeRequestForm() {
        if (this.residencySelect != null && this.requestForm != null && this.requestNotice != null) {
            this.requestForm.classList.add('hidden');
            this.requestNotice.classList.add('hidden');

            this.residencySelect.addEventListener('change', this.handleStateChange);

            if (this.residencySelect.value !== '') {
                this.handleStateChange({ target: this.residencySelect });
            }
        }
    }

    initializeFields() {
        for (let i = 0; i < this.fields.length; i++) {
            const field = this.fields[i];

            field.addEventListener('click', this.handleFieldUpdate);
            field.addEventListener('input', this.handleFieldUpdate);
            field.addEventListener('focusout', this.handleFieldUpdate);

            this.updateFieldLabel(field);
        }
    }

    handleStateChange(event) {
        const selectedState = event.target.value;

        if (selectedState === '') {
            this.requestForm.classList.add('hidden');
            this.requestNotice.classList.add('hidden');
        } else if (selectedState === 'CA') {
            this.requestForm.classList.remove('hidden');
            this.requestNotice.classList.add('hidden');
        } else {
            this.requestForm.classList.add('hidden');
            this.requestNotice.classList.remove('hidden');
        }
    }

    handleFieldUpdate(event) {
        this.updateFieldLabel(event.currentTarget);
    }

    updateFieldLabel(field) {
        const parent = field.parentElement;

        if (parent != null) {
            if (field.value === '') {
                parent.classList.remove('alt');
            } else {
                parent.classList.add('alt');
            }
        }
    }
}

if (!customElements.get('ccpa-form')) {
    customElements.define('ccpa-form', CCPAForm);
}